/**/
import React from "react"
import {Link, withRouter} from 'react-router-dom'
import {Alert, Button, Card, Col, message, Row, Spin, Table, Typography} from "antd"
import {API, Auth} from "aws-amplify"
import BaseUserLite from "./BaseUserLite"
import moment from 'moment'
import {connect} from "react-redux"
import {CustomSpinner} from "../../Components/Spin/CustomSpiner"
import {allDispatch as mapDispatchToProps, allState as mapStateToProps} from "../../Redux/Selectors"
import Chart from "react-apexcharts";
import InvoiceTable from "../../Components/Invoices/InvoiceTable";

const {Text} = Typography;
const fecha_actual = new Date();
const mes_actual = fecha_actual.getMonth();
const year_actual = (fecha_actual.getFullYear() - 2000)
const meses = ['Ene-', 'Feb-', 'Mar-', 'Abr-', 'May-', 'Jun-', 'Jul-', 'Ago-', 'Sept-', 'Oct-', 'Nov-', 'Dic-'];

const lastmonth = [mes_actual - 11 >= 0 ? meses[mes_actual - 11] + year_actual : meses[mes_actual + 1] + (year_actual - 1),
    mes_actual - 10 >= 0 ? meses[mes_actual - 10] + year_actual : meses[mes_actual + 2] + (year_actual - 1),
    mes_actual - 9 >= 0 ? meses[mes_actual - 9] + year_actual : meses[mes_actual + 3] + (year_actual - 1),
    mes_actual - 8 >= 0 ? meses[mes_actual - 8] + year_actual : meses[mes_actual + 4] + (year_actual - 1),
    mes_actual - 7 >= 0 ? meses[mes_actual - 7] + year_actual : meses[mes_actual + 5] + (year_actual - 1),
    mes_actual - 6 >= 0 ? meses[mes_actual - 6] + year_actual : meses[mes_actual + 6] + (year_actual - 1),
    mes_actual - 5 >= 0 ? meses[mes_actual - 5] + year_actual : meses[mes_actual + 7] + (year_actual - 1),
    mes_actual - 4 >= 0 ? meses[mes_actual - 4] + year_actual : meses[mes_actual + 8] + (year_actual - 1),
    mes_actual - 3 >= 0 ? meses[mes_actual - 3] + year_actual : meses[mes_actual + 9] + (year_actual - 1),
    mes_actual - 2 >= 0 ? meses[mes_actual - 2] + year_actual : meses[mes_actual + 10] + (year_actual - 1),
    mes_actual - 1 >= 0 ? meses[mes_actual - 1] + year_actual : meses[mes_actual + 11] + (year_actual - 1),
    meses[mes_actual] + year_actual];

class DashboardUserLite extends React.Component {


    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            user: {},
            dash_data: {},
            invoices: []
        }
    }

    componentDidMount = async () => {
        Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/root/dashboard',
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        }
                    }
                )
                    .then(response => {
                        this.props.UserDataLoad(response['user']);
                        this.setState({user: response['user'], dash_data: response['dashboard'], loading: false});

                        if (this.props.login.adminLite) {
                            return;
                        }
                        if (response['user'].estado_clave_fiscal === 'CREANDO') {
                            if (response['user'].plan === 'Codigo')
                                this.props.history.push('/steps-user/15', {state: {goBackToPayment: false}});
                            else {
                                this.props.history.push('/steps-user/15');
                            }
                        } else if (response['user'].estado_clave_fiscal === 'INACTIVO' || response['user'].estado_clave_fiscal === null) {
                            this.props.history.push('steps-user/0', {state: {goBackToPayment: this.adminLite == null}})
                        }

                    })
                    .catch(err => {
                        // message.error('Sesion vencida, vuelve a loguearte por favor')
                        // this.props.Logout()
                        // this.props.history.push('/login')
                    })
            })
            .catch(err => {
                message.error('Sesion vencida, vuelve a loguearte por favor')
                this.props.Logout()
                this.props.history.push('/login')
            })

    }

    render() {
        if (this.state.loading) {
            return (
                <BaseUserLite selected='dashboard'>
                    <Row type="flex" justify="space-around" align="middle">
                        <Col style={{minHeight: '360px'}}>
                            <Spin indicator={CustomSpinner}/>
                        </Col>
                    </Row>
                </BaseUserLite>
            )
        } else {

            let options = {
                chart: {
                    id: "Facturacion"
                },
                xaxis: {
                    type: 'time',
                    time: {
                        unit: 'Month'
                    },
                    categories: lastmonth
                },
                yaxis: {
                    min: 0,
                    decimalsInFloat: 0,
                    forceNiceScale: true,
                    labels: {
                        formatter: (value) => parseInt(value),
                    }
                },
                colors: ['#8764c8', '#2de058'],
                stroke: {
                    width: [0, 3]
                },
                markers: {
                    size: [0, 4]
                }
            }
            let roundData= this.state.dash_data.facturacion.map(value =>{
                return value.toFixed(2)
            })
            let series = [
                {
                    type: 'column',
                    name: "Facturacion",
                    data: roundData
                },
            ]

            let claveIncorrecta = this.state.user.estado_clave_fiscal === 'ERROR_CLAVE_INVALIDA';
            
            return (


                <BaseUserLite
                    selected="dashboard"
                >
                    { claveIncorrecta ? <Alert
                        message='Debés cargar tu clave fiscal'
                        description={<>Para que puedas usar Liqui, necesitamos tu clave fiscal. Haz click <Link to='/micuenta-lite'>Aquí</Link> para actualizarla.</>}
                        type="error"
                        showIcon
                        closable
                        style={{ marginBottom: '10px' }}
                    /> : null}
                    <Row gutter={[8, 12]} style={{marginTop: '6px'}}>
                        <Col>
                            <Card
                                xs={24}
                                title={"Mi facturación"}
                                style={{textAlign: 'left'}}
                            >
                                {
                                    this.state.loading ?
                                        <Spin></Spin>
                                        :
                                        <Chart
                                            options={options}
                                            series={series}
                                            height='200px'
                                            width="100%"
                                        />
                                }
                            </Card>
                        </Col>
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                            <div key={'1'} style={{flex: 1}}>
                                <Card title="Ultimas Facturas" style={{marginLeft: 3}}>
                                    <InvoiceTable
                                        dashboard={false}
                                    />
                                </Card>
                            </div>
                        </div>

                    </Row>

                </BaseUserLite>

            );
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DashboardUserLite));
